'use strict';

var $ = require('jquery');
var StepTitleView = require('./step-title').default;

export default StepTitleView.extend({

  onRender: function () {
    $('.step-title-back').css('display', 'initial');
    this.renderPicker();
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    this.trigger('load-location-list');
  },

});
